import Vue from 'vue'
import store from '../../store'

const NODE_ENV = 'production';
// const NODE_ENV = 'development';

if (process.env.NODE_ENV === NODE_ENV) {
  Vue.config.errorHandler = function(err, vm, info, a) {
    Vue.nextTick(() => {
      store.dispatch('addErrorLog', {
        err,
        vm,
        info,
        url: window.location.href
      })
      console.error(err, info)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorLog/errorLog.js